import { render, staticRenderFns } from "./SvgHomePointsPicto.vue?vue&type=template&id=1b83e61d&scoped=true"
import script from "./SvgHomePointsPicto.vue?vue&type=script&lang=js"
export * from "./SvgHomePointsPicto.vue?vue&type=script&lang=js"
import style0 from "./SvgHomePointsPicto.vue?vue&type=style&index=0&id=1b83e61d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b83e61d",
  null
  
)

export default component.exports